<nav mat-tab-nav-bar [tabPanel]="tabPanel" class="p-1">
    @if (routeNavId !== rootNavId) {
        <a class="back" href="#" (click)="clickDropdown(navService.currNav()?.parentNav)">
            <fa-icon [icon]="faIconName.faArrowLeft" class="back-arrow"></fa-icon>
        </a>
    }
    @if (!loopNavRoutes?.length && navService.currSelectedMainNavMenu()) {
        <a mat-tab-link class="subnav-item link-active" #navLink>
            <span>{{ navService.currOpenPrimaryNavMenu() }}</span>
        </a>
    }
    @for (route of loopNavRoutes; track route.index; let i = $index) {
        @if (
            route.ellipseBefore &&
            !navService.shouldShowRouteLink(route, navRoutes, route.index) &&
            !navService.shouldShowRouteLink(navRoutes[route.index - 1], navRoutes, route.index)
        ) {
            <a mat-tab-link class="ellipse">...</a>
        }
        @if (route.ellipseBefore || route.ellipseAfter || navService.shouldShowRouteLink(route, navRoutes)) {
            <a
                mat-tab-link
                class="subnav-item"
                #navLink
                [class.link-active]="hrefLocation?.includes(route?.activeNavLink)"
                [routerLinkActiveOptions]="{ exact: route.exact }"
                [queryParams]="route.queryParams"
                (click)="clickedNav.emit(true); redirect(route)"
                [routerLink]="route.path"
            >
                @if (route.name !== 'Back') {
                    <span>{{ route.name }}</span>
                } @else {
                    <span>
                        <fa-icon [icon]="faIconName.faArrowLeft" class="back-arrow"></fa-icon>
                    </span>
                }
            </a>
        }
        @if (
            route.ellipseAfter &&
            !navService.shouldShowRouteLink(route, navRoutes) &&
            !navService.shouldShowRouteLink(navRoutes[route.index + 1], navRoutes)
        ) {
            <a mat-tab-link class="ellipse">...</a>
        }
        @if (route && route.children && !route.hasSideNav) {
            <a mat-tab-link class="dropdown" class="subnav-item" href="#" (click)="clickDropdown(route)"
                >{{ route.name }} ▼</a
            >
        }
    }
</nav>

<!-- <nav mat-tab-nav-bar [tabPanel]="tabPanel">
	<a *ngIf="routeNavId !== rootNavId" class="back" href="#" (click)="clickDropdown(routeNavId, true)">
		<fa-icon [icon]="faIconName.faArrowLeft" class="back-arrow"></fa-icon>
	</a>
	<ng-container *ngFor="let route of loopNavRoutes">
		<a mat-tab-link
			*ngIf="
				route.ellipseBefore &&
				!navService.shouldShowRouteLink(route, navRoutes, route.index) &&
				!navService.shouldShowRouteLink(navRoutes[route.index - 1], navRoutes, route.index)"
				class="ellipse"
		>
			...
		</a>
		<a mat-tab-link
			*ngIf="route.ellipseBefore || route.ellipseAfter || navService.shouldShowRouteLink(route, navRoutes)"
			class="subnav-item"
			[class.link-active]="route.path.includes(hrefLocation)"
			[routerLinkActiveOptions]="{ exact: route.exact }" 
			[queryParams]="route.queryParams" 
			[target]="route.openNewTab ? '_blank' : ''"
			(click)="clickedNav.emit(true); redirect(route.path)"
		>
			<span *ngIf="route.name != 'Back'">{{ route.name }}</span>
			<span *ngIf="route.name == 'Back'">
				<fa-icon [icon]="faIconName.faArrowLeft" class="back-arrow"></fa-icon>
			</span>
		</a>
		<a mat-tab-link
			*ngIf="
				route.ellipseAfter &&
				!navService.shouldShowRouteLink(route, navRoutes) &&
				!navService.shouldShowRouteLink(navRoutes[route.index + 1], navRoutes)"
				class="ellipse"
		>
			...
		</a>
		<a mat-tab-link
			*ngIf="route && route.children && !route.hasSideNav" class="dropdown"
			class="subnav-item" 
			href="#" 
			(click)="clickDropdown(route.id)"
		>
			{{ route.name }} ▼
		</a>
	</ng-container>
</nav> -->
